import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { useCallback, useEffect, useRef, useState } from "react";
import dispositivoServicio from "../../services/dispositivo/dispositivoService";
import { IFilterCombo } from "../../Interfaces/IDispositivos";
export const useComboTablets = () => {
  const [tabletsCombo, setTabletsCombo] = useState<IComboBoxOption[]>([]);
  const [searchCombo, setSearchCombo] = useState<IFilterCombo>({ search: "" });
  const comboBoxRefTablets = useRef<IComboBox>(null);
  const _openOptionDispositivos = useCallback(
    () => comboBoxRefTablets.current?.focus(true),
    []
  );
  const onClickComboTablets = () => comboBoxRefTablets.current?.focus(true);
  const _onkeyUpSearchDispositivo = (event: React.KeyboardEvent<IComboBox>) => {
    _openOptionDispositivos();
    let { value } = event?.target as HTMLInputElement;
    setSearchCombo({ search: value });
  };

  const dataComboTablets = () => {
    dispositivoServicio
      .postComboDispositivoAndroid(searchCombo)
      .then((res) => {
        if (res.status === 200) {
          console.log("Esta es la data devuelta", res.data);
          setTabletsCombo(res.data);
        }
      })
      .catch((e) => {
        if (e !== undefined) {
          console.log("Error al traer la data de los tablets", e);
        }
      });
  };

  useEffect(() => {
    dataComboTablets();
  }, [searchCombo]);
  return {
    tabletsCombo,
    comboBoxRefTablets,
    _onkeyUpSearchDispositivo,
    onClickComboTablets,
  };
};
